import './App.css';
import PixiGame from './pixiGame';
import SessionExpired from './pixiGame/SessionExpired';
import { useEffect, useState } from 'react';
import { io } from "socket.io-client";
import axios from 'axios';
import { ToastProvider, useToast } from "./ToastNotifications/ToastContext";
import { setJackpotData } from './pixiGame/cashCashPabunot/core/jackpotPanel';
import { getJwtToken, setJeepneyJackpotDataWs } from './pixiGame/jeepneyGo/core/gameService';
import { networkData } from './pixiGame/cashCashPabunot/core/data';
import { globalData } from './pixiGame/jeepneyGo/core/globalData';
import { getJwt, settuktukJackpotDataWs } from './pixiGame/TukTukGold/core/gameService';
import { globalData as tuktukData } from './pixiGame/TukTukGold/core/globalData';
import { fruitData } from './pixiGame/fruitFiesta/core/data';
import { getFruitToken, setSliceNGoJackpotDataWs } from './pixiGame/fruitFiesta/core/gameService';

const AppContent = () => {
  const [sessionExpired, setSessionExpired] = useState(false)
  const params = new URLSearchParams(window.location.search);
  const [userToken, setUserToken] = useState('')
  const { addToast } = useToast();

  async function getToken() {

    const data = {
      currencyCode: params.get("currency"),
      operatorId: params.get("operator"),
      operatorUserToken: params.get("token"),
      gameId: params.get("gameId")
    }
    console.log("user-login", data);
    
    if (params?.size) {
      console.log("user-login", data);
      await axios.post(process.env.REACT_APP_BACKEND_URL_HTTP + '/user/login', data)
        .then((response) => {
          console.log("processed-login", response);
          
        
          if(params.get('baseGameId') == 1){
            globalData.response = response?.data;
            getJwtToken()
          } else if(params.get('baseGameId') == 3){
            tuktukData.response = response?.data;            
            getJwt()
          }
          else{
            networkData.response = response?.data;
            networkData.isJackpot = networkData?.response.data?.gameSettings?.isJackpotActive
            networkData.showAutoTurbo = response?.data?.data?.gameSettings?.enableAutoplayTurbo;            
          } 

          if(params.get('baseGameId') == 4){
            fruitData.response = response?.data;
            getFruitToken();
          }

          sessionStorage.clear() // clearing the session storage before setting new values
          response?.data && sessionStorage.setItem('tk', window.btoa(JSON.stringify(response?.data)))
          setUserToken(response?.data);
        })
        .catch((error) => {
          if (error.response?.data?.errors?.[0]?.name == "InvalidToken") {
            console.error(error.message)
          }
          console.error('Error during POST request:', error);
        });
    }
  }

  async function getGameDetails() {
    const data = {
      currencyCode: params.get("currency"),
      operatorId: params.get("operator"),
      operatorUserToken: params.get("token"),
      gameId: params.get("gameId")
    }

    console.log("game-details", data);
    

    let token = JSON?.parse(window?.atob(sessionStorage?.getItem('tk'))); 
    token = token.data.accessToken;

    if(params.get('baseGameId') == 1){
      globalData.jwtToken = token
    } else if(params.get('baseGameId') == 3){
      tuktukData.jwtToken = token
    }
    else {
      networkData.jwtToken = token;
    } 

    if(params.get('baseGameId') == 4){
      fruitData.jwtToken = token;
    }

    await axios.post(
      process.env.REACT_APP_HEALTH_CHECK_API+'/api/v1/common/game-details',
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then((response)=>{

      if(params.get('baseGameId') == 1){
        globalData.response = response?.data;
        getJwtToken()
      } else if(params.get('baseGameId') == 3){
        tuktukData.response = response?.data;
        getJwt()
      }
      else {
        networkData.response = response?.data
        networkData.isJackpot = networkData?.response.data?.gameSettings?.isJackpotActive
        networkData.showAutoTurbo = networkData.response.data?.gameSettings?.enableAutoplayTurbo;            
      }

      if(params.get('baseGameId') == 4){
        fruitData.response = response?.data;
        getFruitToken()
      }
      setUserToken(response?.data);
    })
    .catch((error)=>{
      if (error.response?.data?.errors?.[0]?.name == "InvalidToken") {
        console.error(error.message)
      }
      console.error('Error during POST request:', error);
    })
  }

  useEffect(() => {
    console.log("session-mount", sessionStorage?.getItem('tk'));
    
    if (performance.navigation.type === 1) {
      getGameDetails()
    } else {
      getToken()
    }    
  }, [])

  useEffect(() => {

    const params = new URLSearchParams(window.location.search);
    const baseGameId = params.get("baseGameId");
    console.log("base game id", baseGameId)

    if (userToken) {
      const tokenValue = encodeURIComponent(`Bearer ${userToken?.data?.accessToken}`)
      const SOCKET_URL = `${process.env.REACT_APP_BACKEND_URL_WS}/logout?authorization=${tokenValue}`
      const JACKPOT_SOCKET_URL = `${process.env.REACT_APP_BACKEND_URL_WS}/jackpot?authorization=${tokenValue}`
      const ws = io(SOCKET_URL, {
        transports: ["websocket"],
      });
      const jws = io(JACKPOT_SOCKET_URL, {
        transports: ["websocket"],
      });

      ws.on("connect", () => {
        console.log("Connected to WebSocket /logout namespace");
      });

      ws.on("logout", (data) => {
        console.log("Received logout event:", data.message);
        addToast(data?.message, "error")
        ws.disconnect();
        setTimeout(() => setSessionExpired(true), 1500)
      });


      ws.on("disconnect", (reason) => {
        console.log("Disconnected from WebSocket:", reason);
      });

      jws.on("jackpot", (data) => {
        //TODO: DO NOT UNCOMMENT !!  COMPLETING PROPER GAME FLOW.
        console.log("base game id", baseGameId)
        if (baseGameId == 1)
          setJeepneyJackpotDataWs(data?.message, data?.userId)
        else if(baseGameId == 2) {
          setJackpotData(data?.message, data?.userId)
        } else if(baseGameId == 3) {
          settuktukJackpotDataWs(data?.message, data?.userId)
        } else {
          setSliceNGoJackpotDataWs(data?.message, data?.userId)
        }
      });

      jws.on("connect", () => {
        console.log("Connected to WebSocket /jackpot namespace");
      });


      jws.on("disconnect", (reason) => {
        console.log("Disconnected from Jackpot WebSocket:", reason);
      });

      return () => {
        ws.disconnect();
        jws.disconnect();
      };
    }
  }, [userToken]);

  return (
    <div className="App">
      {sessionExpired ? <SessionExpired setSessionExpired={setSessionExpired} /> : <PixiGame setSessionExpired={setSessionExpired} />}
    </div>
  );
}

export default function App() {
  return (
    <ToastProvider>
      <AppContent />
    </ToastProvider>
  );
}
